import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';
import {
  LEASE_DEALS_PATH,
  LEASE_DEALS_STATE_PATH,
  LEASE_DEALS_MONTHLY_199_PATH,
  LEASE_DEALS_BEST_BODY_TYPE_PATH,
  LEASE_DEALS_BEST_ENGINE_TYPE_PATH,
  LEASE_DEALS_BEST_TYPE_PATH,
  LEASE_DEALS_MAKE_PATH,
  LEASE_DEALS_MAKE_CITY_STATE_PATH,
} from 'site-modules/shared/constants/lease-deals/routes';

const leaseDealsTypePage = getLoadablePage(
  () => import(/* webpackChunkName: "lease-deals-type" */ '../../lease-deals/pages/lease-deals-type-definition')
);

export const routes = [
  {
    path: [LEASE_DEALS_BEST_BODY_TYPE_PATH, LEASE_DEALS_BEST_ENGINE_TYPE_PATH, LEASE_DEALS_BEST_TYPE_PATH],
    exact: true,
    page: leaseDealsTypePage,
    enableLooseEtag: true,
  },
  {
    path: LEASE_DEALS_MONTHLY_199_PATH,
    exact: true,
    page: leaseDealsTypePage,
    enableLooseEtag: true,
  },
  {
    path: [LEASE_DEALS_MAKE_PATH, LEASE_DEALS_MAKE_CITY_STATE_PATH],
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "lease-deals-make" */ '../../lease-deals/pages/lease-deals-make-definition')
    ),
    enableLooseEtag: true,
    shouldCallParseApi: true,
  },
  {
    path: LEASE_DEALS_PATH,
    exact: true,
    page: getLoadablePage(() => {
      return import(/* webpackChunkName: "lease-deals" */ '../../lease-deals/pages/lease-deals-definition');
    }),
    enableLooseEtag: true,
  },
  {
    path: LEASE_DEALS_STATE_PATH,
    exact: true,
    page: getLoadablePage(() => {
      return import(/* webpackChunkName: "lease-deals-state" */ '../../lease-deals/pages/lease-deals-state-definition');
    }),
    enableLooseEtag: true,
    shouldCallParseApi: true,
  },
];
